import React from 'react';
import LoginHeader from '../../components/Headers/LoginHeader';
import LoginFooter from '../../components/Footers/LoginFooter';
import GovernmentRegistration from '../../components/GovernmentRegistration';

const GovernmentRegistrationPage = () => {
  return (
    <>  
      <LoginHeader />
      <main>
        <GovernmentRegistration />
      </main>
      <LoginFooter />
    </>
  )
}

export default GovernmentRegistrationPage;